module.exports = __webpack_public_path__ + "static/media/file-import-solid.3e6f5ba3.svg";